import { memo } from 'react';

import {
  FONT_GENERATOR_TOOL,
  BACKGROUND_REMOVER_TOOL,
  PROFILE_PICTURE_TOOL,
  JPG_TO_PDF_TOOL,
  COLOR_PICKER_TOOL,
} from '../../../data/tools';
import { Analytics } from '../../../services';
import { SingleToolAppIcon } from '../../common/SingleToolAppIcon';

import useStyles from './styles';
import ResultsContainer from './ResultsContainer';

interface IDefaultResultsProps {
  analytics?: Analytics;
  pageName?: string;
  toolName: string;
}

const TOOLS = [
  FONT_GENERATOR_TOOL,
  BACKGROUND_REMOVER_TOOL,
  PROFILE_PICTURE_TOOL,
  JPG_TO_PDF_TOOL,
  COLOR_PICKER_TOOL,
];

function DefaultResults({ analytics, pageName, toolName }: IDefaultResultsProps) {
  const classes = useStyles();

  return (
    <ResultsContainer>
      <ul className={classes.defaultResultsList}>
        {TOOLS.map((tool) => (
          <li key={tool.id}>
            <a
              className={classes.defaultResultsLink}
              href={tool.href}
              key={tool.name}
              onClick={() => {
                analytics && analytics.searchResultsClick(pageName, toolName, tool.id);
              }}
            >
              <SingleToolAppIcon icon={tool.icon} size="small" />
              <span>{tool.name}</span>
            </a>
          </li>
        ))}
      </ul>
    </ResultsContainer>
  );
}

export default memo(DefaultResults);
